<template>
  <div class="page-title mt-3">
    <label class="title-box col-1 pr-5">{{ "'" }}</label
    ><strong class="ml-5 page-title">{{ $t("preQuestionnaire") }}</strong>
  </div>
  <div class="mx-5 mt-3">
    <div style="text-align: left">
      <!--Q9貴公司諮詢的問題為?-->
      <div class="m-3" ref="q9hight">
        <div class="qustion-color">
          {{ "9."
          }}<label class="formtext-title"
            >{{ $t("question-9th") }}{{ "*" }}</label
          >
        </div>
        <div v-if="checkQ9 === true" class="form-error-box">
          <label class="form-error-text">{{ Q9Text }}</label>
        </div>
        <label v-else class="form-hint"
          >{{ $t("_pleaseChoose") }}{{ $t("_selectAtLeastOne") }}</label
        >
        <div class="row">
          <div class="col-6">
            <div
              :class="
                question9ans.indexOf('a') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--a 新產品開發打樣及試生產-->
              <div class="inside-box" label for="question9ansA">
                <input
                  type="checkbox"
                  v-model="question9ans"
                  id="question9ansA"
                  value="a"
                />
                <label label for="question9ansA">{{
                  $t("question9th-ans1")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('c') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--c 工程分析與生產線規劃-->
              <div class="inside-box" label for="question9ansC">
                <input
                  type="checkbox"
                  v-model="question9ans"
                  id="question9ansC"
                  value="c"
                />
                <label label for="question9ansC">{{
                  $t("question9th-ans3")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('e') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--e 工程集約、複合化-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  v-model="question9ans"
                  id="question9ansE"
                  value="e"
                />
                <label label for="question9ansE">{{
                  $t("question9th-ans5")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('g') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--g 加工時間與生產製程優化-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  v-model="question9ans"
                  id="question9ansG"
                  value="g"
                />
                <label label for="question9ansG">{{
                  $t("question9th-ans7")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('i') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--i 設備狀態監控及生產資訊可視化-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  v-model="question9ans"
                  id="question9ansI"
                  value="i"
                />
                <label label for="question9ansI">{{
                  $t("question9th-ans9")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('k') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--k 設備維護管理與操控訓練-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  v-model="question9ans"
                  id="question9ansK"
                  value="k"
                />
                <label label for="question9ansK">{{
                  $t("question9th-ans11")
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div
              :class="
                question9ans.indexOf('b') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--b 產線自動化-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  v-model="question9ans"
                  id="question9ansB"
                  value="b"
                />
                <label label for="question9ansB">{{
                  $t("question9th-ans2")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('d') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--d 刀具、夾治具規劃與管理-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  id="question9ansD"
                  v-model="question9ans"
                  value="d"
                />
                <label label for="question9ansD">{{
                  $t("question9th-ans4")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('f') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--f 五軸及車铣程式最佳化-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  id="question9ansF"
                  v-model="question9ans"
                  value="f"
                />
                <label label for="question9ansF">{{
                  $t("question9th-ans6")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('h') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--h 生產排程最佳化-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  id="question9ansH"
                  v-model="question9ans"
                  value="h"
                />
                <label label for="question9ansH">{{
                  $t("question9th-ans8")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('j') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--j ERP與生產資訊串聯-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  id="question9ansJ"
                  v-model="question9ans"
                  value="j"
                />
                <label label for="question9ansJ">{{
                  $t("question9th-ans10")
                }}</label>
              </div>
            </div>
            <div
              :class="
                question9ans.indexOf('l') === -1
                  ? 'unselected-box'
                  : 'selected-box'
              "
            >
              <!--l其他-->
              <div class="inside-box">
                <input
                  type="checkbox"
                  id="question9ansL"
                  v-model="question9ans"
                  value="l"
                />
                <label label for="question9ansL">{{ $t("other") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Q10承上題，請對問題狀況進行描述-->
      <div class="mt-3">
        <div class="qustion-color">
          {{ "10."
          }}<label class="formtext-title">{{ $t("question-10th") }}</label>
        </div>
        <label class="form-magin" label for="question10ans">{{ 1 }}</label>
        <div class="mx-3">
          <textarea
            :placeholder="$t('_fillText')"
            class="col-12"
            v-model="question10ans"
            id="question10ans"
          ></textarea>
        </div>
      </div>
      <!--Q11貴公司所屬產品類別-->
      <div class="mt-3" ref="q11hight">
        <div class="qustion-color">
          {{ "11."
          }}<label class="formtext-title"
            >{{ $t("question-11th") }}{{ "*" }}</label
          >
        </div>
        <div v-if="checkQ11 === true" class="form-error-box">
          <label class="form-error-text">{{ Q11Text }}</label>
        </div>
        <label v-else class="form-magin">{{ 1 }}</label>
        <div class="mx-3">
          <select class="col-12" v-model="question11ans">
            <option value="none" disabled>{{ $t("_pleaseChoose") }}</option>
            <option value="a">{{ $t("question11th-ans1") }}</option>
            <!--a汽車-->
            <option value="b">{{ $t("question11th-ans2") }}</option>
            <!--b機車-->
            <option value="c">{{ $t("question11th-ans3") }}</option>
            <!--c航太-->
            <option value="d">{{ $t("question11th-ans4") }}</option>
            <!--d能源-->
            <option value="e">{{ $t("question11th-ans5") }}</option>
            <!--e家電-->
            <option value="f">{{ $t("question11th-ans6") }}</option>
            <!--f模具-->
            <option value="g">{{ $t("question11th-ans7") }}</option>
            <!--g自行車-->
            <option value="h">{{ $t("question11th-ans8") }}</option>
            <!--h資通訊-->
            <option value="i">{{ $t("question11th-ans9") }}</option>
            <!--i一般部品加工-->
            <option value="j">{{ $t("question11th-ans10") }}</option>
            <!--j學研單位-->
            <option value="k">{{ $t("question11th-ans11") }}</option>
            <!--k電子電儀-->
            <option value="l">{{ $t("question11th-ans12") }}</option>
            <!--l五金-->
            <option value="m">{{ $t("other") }}</option>
            <!--m其他-->
          </select>
        </div>
      </div>
      <!--Q12貴公司的員工人數?-->
      <div class="mt-3" ref="q12hight">
        <div class="qustion-color">
          {{ "12."
          }}<label class="formtext-title"
            >{{ $t("question-12th") }}{{ "*" }}</label
          >
        </div>
        <div v-if="checkQ12 === true" class="form-error-box">
          <label class="form-error-text">{{ Q12Text }}</label>
        </div>
        <label v-else class="form-magin">{{ 1 }}</label>
        <div class="mx-3">
          <select class="col-12" v-model="question12ans">
            <option value="none" disabled>{{ $t("_pleaseChoose") }}</option>
            <!--a 10人以下-->
            <option value="a">{{ $t("question12th-ans1") }}</option>
            <!--b 11-50人-->
            <option value="b">
              {{ "11~50" }}{{ $t("question12th-ans3") }}
            </option>
            <!--c 51-250人-->
            <option value="c">
              {{ "51~250" }}{{ $t("question12th-ans3") }}
            </option>
            <!--d 251-1000人-->
            <option value="d">
              {{ "251~1000" }}{{ $t("question12th-ans3") }}
            </option>
            <!--e 1000人以上-->
            <option value="e">{{ $t("question12th-ans2") }}</option>
          </select>
        </div>
      </div>
      <!--Q13貴公司現有金屬切削工具數量?-->
      <div class="mt-3" ref="q13hight">
        <div class="qustion-color">
          {{ "13."
          }}<label class="formtext-title"
            >{{ $t("question-13th") }}{{ "*" }}</label
          >
        </div>
        <div v-if="checkQ13 === true" class="form-error-box">
          <label class="form-error-text">{{ Q13Text }}</label>
        </div>
        <label v-else class="form-magin">{{ 1 }}</label>
        <div class="mx-3">
          <select class="col-12" v-model="question13ans">
            <option value="none" disabled>{{ $t("_pleaseChoose") }}</option>
            <!--a 10台以下-->
            <option value="a">{{ $t("question13th-ans1") }}</option>
            <!--b 11-50台-->
            <option value="b">
              {{ "11~50" }}{{ $t("question13th-ans2") }}
            </option>
            <!--c 51-100台-->
            <option value="c">
              {{ "51~100" }}{{ $t("question13th-ans2") }}
            </option>
            <!--d 101-200台-->
            <option value="d">
              {{ "101~200" }}{{ $t("question13th-ans2") }}
            </option>
            <!--e 200台以上-->
            <option value="e">{{ $t("question13th-ans3") }}</option>
          </select>
        </div>
      </div>
      <!--Q14貴公司主要的生態型態?-->
      <div class="mt-3" ref="q14hight">
        <div class="qustion-color">
          {{ "14."
          }}<label class="formtext-title"
            >{{ $t("question-14th") }}{{ "*" }}</label
          >
        </div>
        <div v-if="checkQ14 === true" class="form-error-box">
          <label class="form-error-text">{{ Q14Text }}</label>
        </div>
        <label v-else class="form-magin">{{ 1 }}</label>
        <div class="mx-3">
          <div class="row">
            <div class="col-6">
              <div
                :class="
                  question14ans.indexOf('a') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--a少量多樣-->
                <div class="inside-box">
                  <input
                    type="radio"
                    v-model="question14ans"
                    id="question14ansA"
                    value="a"
                  />
                  <label label for="question14ansA">{{
                    $t("question14th-ans1")
                  }}</label>
                </div>
              </div>
              <div
                :class="
                  question14ans.indexOf('c') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--c變種變量-->
                <div class="inside-box">
                  <input
                    type="radio"
                    v-model="question14ans"
                    id="question14ansC"
                    value="c"
                  />
                  <label label for="question14ansC">{{
                    $t("question14th-ans3")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div
                :class="
                  question14ans.indexOf('b') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--b批量生產-->
                <div class="inside-box">
                  <input
                    type="radio"
                    id="question14ansB"
                    v-model="question14ans"
                    value="b"
                  />
                  <label label for="question14ansB">{{
                    $t("question14th-ans2")
                  }}</label>
                </div>
              </div>
              <div
                :class="
                  question14ans.indexOf('d') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--d大量生產-->
                <div class="inside-box">
                  <input
                    type="radio"
                    label
                    id="question14ansD"
                    v-model="question14ans"
                    value="d"
                  />
                  <label label for="question14ansD">{{
                    $t("question14th-ans4")
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Q15貴公司主要使用的設備(選前三)-->
      <div class="mt-3" ref="q15hight">
        <div class="qustion-color">
          {{ "15."
          }}<label class="formtext-title"
            >{{ $t("question-15th") }}{{ "*" }}</label
          >
        </div>
        <label class="form-hint mx-3"
          >{{ $t("_selectOptions1-3") }}{{ "(" }}{{ checkQ15choose
          }}{{ ")" }}</label
        >
        <div class="form-error-box mx-3">
          <!-- <label class="form-error-hint">{{$t('_multipleChoiceQuestions')}}</label> -->
          <label v-if="checkQ15 === true" class="form-error-text">{{
            Q15Text
          }}</label>
        </div>
        <div class="mx-3">
          <div class="row">
            <div class="col-6">
              <div
                :class="
                  question15ans.indexOf('a') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--a立式加工機-->
                <div class="inside-box">
                  <input
                    type="checkbox"
                    v-model="question15ans"
                    id="question15ansA"
                    value="a"
                  />
                  <label label for="question15ansA">{{
                    $t("question15th-ans1")
                  }}</label>
                </div>
              </div>
              <div
                :class="
                  question15ans.indexOf('c') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--c車铣複合機-->
                <div class="inside-box">
                  <input
                    type="checkbox"
                    v-model="question15ans"
                    id="question15anC"
                    value="c"
                  />
                  <label label for="question15anC">{{
                    $t("question15th-ans3")
                  }}</label>
                </div>
              </div>
              <div
                :class="
                  question15ans.indexOf('e') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--e臥式加工機-->
                <div class="inside-box">
                  <input
                    type="checkbox"
                    v-model="question15ans"
                    id="question15anE"
                    value="e"
                  />
                  <label label for="question15anE">{{
                    $t("question15th-ans5")
                  }}</label>
                </div>
              </div>
              <div
                :class="
                  question15ans.indexOf('g') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--g臥式CNC車床-->
                <div class="inside-box">
                  <input
                    type="checkbox"
                    v-model="question15ans"
                    id="question15anG"
                    value="g"
                  />
                  <label label for="question15anG">{{
                    $t("question15th-ans7")
                  }}</label>
                </div>
              </div>
              <div
                :class="
                  question15ans.indexOf('i') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--i其他-->
                <div class="inside-box">
                  <input
                    type="checkbox"
                    v-model="question15ans"
                    id="question15anI"
                    value="i"
                  />
                  <label label for="question15anI">{{ $t("other") }}</label>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div
                :class="
                  question15ans.indexOf('b') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--b立式CNC車床-->
                <div class="inside-box">
                  <input type="checkbox" v-model="question15ans" id="question15anB" value="b" />
                  <label label for="question15anB">{{ $t("question15th-ans2") }}</label>
                </div>
              </div>
              <div
                :class="
                  question15ans.indexOf('d') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--d五軸加工機-->
                <div class="inside-box">
                  <input type="checkbox" v-model="question15ans" id="question15anD" value="d" />
                  <label label for="question15anD">{{ $t("question15th-ans4") }}</label>
                </div>
              </div>
              <div
                :class="
                  question15ans.indexOf('f') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--f鑽孔攻牙機-->
                <div class="inside-box">
                  <input type="checkbox" v-model="question15ans" id="question15anF" value="f" />
                  <label label for="question15anF">{{ $t("question15th-ans6") }}</label>
                </div>
              </div>
              <div
                :class="
                  question15ans.indexOf('h') === -1
                    ? 'unselected-box'
                    : 'selected-box'
                "
              >
                <!--h專用機-->
                <div class="inside-box">
                  <input type="checkbox" v-model="question15ans" id="question15anH" value="h" />
                  <label label for="question15anH">{{ $t("question15th-ans8") }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--送出-->
      <div>
        <button class="offset-5 mt-5 col-2 btn" @click="submitMemberData">
          {{ $t("nextPage") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, onMounted, defineEmits } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
// const listData = defineProps({
//   item: Object,
// });
// /**接收基本資料 */
// onBeforeUpdate(() => {
//   console.log(listData.item)
// })
// watch(listData.item,(newData)=>{
//   console.log(newData)
//   if(newData.name!==''&&newData.compant!==''&&newData.positionTitle!==''&&newData.companyPhone!==''&&newData.phoneNumber!==''&&newData.email!==''){
//     formData.value.name=newData.name;
//     formData.value.company=newData.company;
//     formData.value.department=newData.department;
//     formData.value.positionTitle=newData.positionTitle;
//     formData.value.companyPhone=newData.companyPhone;
//     formData.value.phoneNumber=newData.phoneNumber;
//     formData.value.email=newData.email;
//     formData.value.time=newData.time;
//   }else{
//     emit("changePage",{type:'error',page:2})
//   }
// })
/**表單內容 */
const question9ans = ref([]); //多選
const question10ans = ref(""); //文字
const question11ans = ref("none"); //下拉
const question12ans = ref("none"); //下拉
const question13ans = ref("none"); //下拉
const question14ans = ref(""); //單選
const question15ans = ref([]); //多選
const formData = ref({
  // name: "",
  // company: "",
  // department: "",
  // positionTitle: "",
  // companyPhone: "",
  // phoneNumber: "",
  // email: "",
  // time: "",
  Q9: [],
  Q10: "",
  Q11: "",
  Q12: "",
  Q13: "",
  Q14: "",
  Q15: [],
});
/**欄位位置 */
const q9hight = ref(0);
const q11hight = ref(0);
const q12hight = ref(0);
const q13hight = ref(0);
const q14hight = ref(0);
const q15hight = ref(0);

const qustion9 = ref(0); //貴公司欲諮詢的問題為
const qustion11 = ref(0); //貴公司所屬產品類別
const qustion12 = ref(0); //貴公司的員工人數
const qustion13 = ref(0); //貴公司現有金屬切削工具數量
const qustion14 = ref(0); //貴公司主要的生產型態是
const qustion15 = ref(0); //貴公司主要使用的設備(選前三)

/**取得元素高度 */
onMounted(() => {
  qustion9.value = q9hight.value.offsetTop;
  qustion11.value = q11hight.value.offsetTop;
  qustion12.value = q12hight.value.offsetTop;
  qustion13.value = q13hight.value.offsetTop;
  qustion14.value = q14hight.value.offsetTop;
  qustion15.value = q15hight.value.offsetTop;
});
/**位置判斷 */
const toTop = (top) => {
  document.body.scrollTop = top;
  document.documentElement.scrollTop = top;
};
/**錯誤提示 */
const checkQ9 = ref(false);
const checkQ11 = ref(false);
const checkQ12 = ref(false);
const checkQ13 = ref(false);
const checkQ14 = ref(false);
const checkQ15 = ref(false);

const Q9Text = ref("");
const Q11Text = ref("");
const Q12Text = ref("");
const Q13Text = ref("");
const Q14Text = ref("");
const Q15Text = ref("");
const checkQ15choose = ref(t("selectedCount") + 0 + t("piece"));

/**回傳父層 */
const emit = defineEmits({
  formData: Array,
  count: Number,
  changePage: Object,
});
/**進度條 */
const countQ9 = ref(false);
const countQ15 = ref(false);
watch(
  [
    countQ9,
    question10ans,
    question11ans,
    question12ans,
    question13ans,
    question14ans,
    countQ15,
  ],
  ([newQ9, newQ10, newQ11, newQ12, newQ13, newQ14, newQ15]) => {
    const count = ref(0);
    if (newQ9 === true) {
      count.value++;
    }
    if (newQ11 !== "none") {
      formData.value.Q11 = newQ11;
      count.value++;
    } else {
      formData.value.Q11 = "";
    }
    if (newQ12 !== "none") {
      formData.value.Q12 = newQ12;
      count.value++;
    } else {
      formData.value.Q12 = "";
    }
    if (newQ13 !== "none") {
      formData.value.Q13 = newQ13;
      count.value++;
    } else {
      formData.value.Q13 = "";
    }
    if (newQ14 !== "none") {
      formData.value.Q14 = newQ14;
      count.value++;
    } else {
      formData.value.Q14 = "";
    }
    if (newQ15 === true) {
      count.value++;
    }
    if (newQ10 !== "") {
      formData.value.Q10 = newQ10;
    } else {
      formData.value.Q10 = "";
    }
    if (count.value > 0) {
      emit("count", count.value);
    } else {
      emit("count", -1);
    }
  }
);
watch(question9ans, (newQ9) => {
  if (newQ9.length > 0) {
    formData.value.Q9 = newQ9;
    countQ9.value = true;
  } else {
    formData.value.Q9 = [];
    countQ9.value = false;
  }
});
watch(question15ans, (newQ15) => {
  if (newQ15.length >= 0 && newQ15.length < 4) {
    formData.value.Q15 = newQ15;
    checkQ15.value = false;
    checkQ15choose.value = t("selectedCount") + newQ15.length + t("piece");
    countQ15.value = true;
  } else if (newQ15.length >= 4) {
    formData.value.Q15 = [];
    countQ15.value = false;
    checkQ15.value = true;
    checkQ15choose.value = t("selectedCount") + newQ15.length + t("piece");
    Q15Text.value = t("decrease") + (newQ15.length - 3) + t("piece");
  } else {
    checkQ15choose.value = t("selectedCount") + newQ15.length + t("piece");
    formData.value.Q15 = [];
    countQ15.value = false;
  }
});
/**檢查 */
const checkkey = ref(false);
const datacheck = () => {
  checkkey.value = false;
  if (formData.value.Q9.length === 0) {
    checkQ9.value = true;
    Q9Text.value = t("_pleaseChoose") + t("_selectAtLeastOne");
    toTop(qustion9.value);
    checkkey.value = true;
    return false;
  } else {
    checkQ9.value = false;
    Q9Text.value = "";
  }
  if (formData.value.Q11 === "") {
    checkQ11.value = true;
    Q11Text.value = t("requiredFields");
    toTop(qustion11.value);
    checkkey.value = true;
    return false;
  } else {
    checkQ11.value = false;
    Q11Text.value = "";
  }
  if (formData.value.Q12 === "") {
    checkQ12.value = true;
    Q12Text.value = t("requiredFields");
    toTop(qustion12.value);
    checkkey.value = true;
    return false;
  } else {
    checkQ12.value = false;
    Q12Text.value = "";
  }
  if (formData.value.Q13 === "") {
    checkQ13.value = true;
    Q13Text.value = t("requiredFields");
    toTop(qustion13.value);
    checkkey.value = true;
    return false;
  } else {
    checkQ13.value = false;
    Q13Text.value = "";
  }
  if (formData.value.Q14 === "") {
    checkQ14.value = true;
    Q14Text.value = t("requiredFields");
    toTop(qustion14.value);
    checkkey.value = true;
    return false;
  } else {
    checkQ14.value = false;
    Q14Text.value = "";
  }
  if (formData.value.Q15.length === 0 && question15ans.value.length === 0) {
    checkQ15.value = true;
    Q15Text.value = t("requiredFields");
    toTop(qustion15.value);
    checkkey.value = true;
    return false;
  } else if (
    formData.value.Q15.length === 0 &&
    question15ans.value.length >= 4
  ) {
    countQ15.value = false;
    checkQ15.value = true;
    Q15Text.value =
      t("decrease") + (question15ans.value.length - 3) + t("piece");
    checkkey.value = true;
    return false;
  } else {
    checkQ15.value = false;
    Q15Text.value = "";
  }
};
/**送出 */
const submitMemberData = () => {
  datacheck();
  if (checkkey.value === true) {
    return false;
  }
  ///api
  console.log(formData.value);
  emit("formData", formData.value);
  emit("changePage", { type: "success", page: 3 });
};
</script>
